import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const columnSizes = {
	size35: 35,
	size70: 70,
	size80: 80,
	size85: 85,
	size88: 88,
	size90: 90,
	size95: 95,
	size100: 100,
	size105: 105,
	size115: 115,
	size120: 120,
	size130: 130,
	size135: 135,
	size140: 140,
	size150: 150,
	size155: 155,
	size160: 160,
	size170: 170,
	size180: 180,
	size185: 185,
	size190: 190,
	size200: 200,
	size215: 215,
	size250: 250,
	size300: 300,
	size335: 335,
	size360: 360,
	size450: 450,
};

export const TableFilterTypes = {
	SELECT: 'select',
	MULTISELECT: 'multiselect',
} as const;

export type TTableFilterTypes = TValueOfStringRecord<typeof TableFilterTypes>
